(() => {
  if (customElements.get('products-carousel')) {
    return;
  }

  class ProductsCarousel extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        slidesPerView: 'auto',
        spaceBetween: 12,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 32,
          },
        },
      };
      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }
      this.slider = new Swiper(
        this.querySelector('[data-slider]'),
        this.options,
      );
    }
  }

  customElements.define('products-carousel', ProductsCarousel);
})();
